import { SET_CURRENT_FLIGHT_BY_ID } from "@live/store/LiveActions";
import { FLICK_TARGET_SWITCH, SET_IS_FLIGHT_FOCUS } from "@live/store/LiveMutations";
import { liveStore } from "@live/store/LiveStore";
import { defineComponent } from "vue";
export default defineComponent({
    data: function () {
        return {
            searchInput: "",
        };
    },
    computed: {
        searchPool: function () {
            const serverDetail = liveStore.getters.getCurrentServerDetail;
            const flights = serverDetail == null ? [] : serverDetail.flights;
            return flights.map((flight) => {
                let username = flight.username.trim();
                if (username == "") {
                    username = "No Username";
                }
                return { flightId: flight.id, text: `${username} - ${flight.callsign}` };
            });
        },
        results: function () {
            const searchPool = this.searchPool;
            const searchInput = this.searchInput.trim().toLowerCase();
            if (this.searchInput.trim() == "") {
                return searchPool;
            }
            return searchPool.filter((searchField) => searchField.text.trim().toLowerCase().includes(searchInput));
        }
    },
    methods: {
        onClick: function (flightId) {
            liveStore.commit(SET_IS_FLIGHT_FOCUS, true);
            liveStore.dispatch(SET_CURRENT_FLIGHT_BY_ID, { id: flightId });
            liveStore.commit(FLICK_TARGET_SWITCH);
            this.$emit("onClose");
        }
    },
    emits: ["onClose"]
});
